import { useQuery } from "@tanstack/react-query";

import { MODULE_NAMES } from "@/constants/modules";
import { TEN_MINUTES_MS } from "@/constants/time";
import { LIST_QUERY_KEY } from "@/utils/query";

import { fetchPaymentProviderModelsListData } from "./paymentProviderApi";

export const usePaymentProviderModels = () =>
  useQuery({
    queryKey: [MODULE_NAMES.PAYMENT_PROVIDER_MODELS, LIST_QUERY_KEY],
    queryFn: async () => {
      const { data = [] } = await fetchPaymentProviderModelsListData();
      return {
        paymentProviderModelsList: data,
        paymentProviderModelsObject: data.reduce<Record<string, string>>(
          (acc, model) => {
            acc[model.id || ""] = String(model.name ?? model.id);
            return acc;
          },
          {},
        ),
      };
    },
    staleTime: TEN_MINUTES_MS,
  });
